import { makeAutoObservable, runInAction } from 'mobx';
import { TvProvider } from '../../data';

class DictionaryState {
  _subscription?: { title: string; text: string } = undefined;

  constructor() {
    makeAutoObservable(this);
  }

  get subscription() {
    return this._subscription;
  }

  async getSubscription() {
    if (this._subscription !== undefined) return;
    const res = await TvProvider.info('subscription');
    runInAction(() => (this._subscription = res));
  }
}

export default new DictionaryState();
